module.exports = __webpack_public_path__ + "static/media/gsoft-khaki.0fd353be.jpg";